import { render, staticRenderFns } from "./PromotionSettings.vue?vue&type=template&id=cfc58d2c&scoped=true"
import script from "./PromotionSettings.vue?vue&type=script&lang=js"
export * from "./PromotionSettings.vue?vue&type=script&lang=js"
import style0 from "./PromotionSettings.vue?vue&type=style&index=0&id=cfc58d2c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc58d2c",
  null
  
)

export default component.exports